export const conditionLabels = {
    1: 'Clean / OK',
    2: 'Needs Cleaning',
    3: 'Needs Painting',
    4: 'Needs Repair',
    5: 'Missing',
    6: 'Not Applicable'
};

export const sectionDisplayNames = {
    entrances_hall_closets: 'Entrance / Hall / Closets',
    kitchen: 'Kitchen',
    living_dining_room: 'Living / Dining Room',
    bedroom1: 'Bedroom 1',
    bedroom2: 'Bedroom 2',
    bedroom3: 'Bedroom 3',
    bathroom1: 'Bathroom Main',
    bathroom2: 'Bathroom 2',
    miscellaneous: 'Miscellaneous',
    other_duplex: 'House / Duplex',
};

export const sectionIcons = {
    entrances_hall_closets: 'home',
    kitchen: 'shopping-bag',
    living_dining_room: 'tv',
    bedroom1: 'home',
    bedroom2: 'home',
    bedroom3: 'home',
    bathroom1: 'droplet',
    bathroom2: 'droplet',
    miscellaneous: 'alert-circle',
    other_duplex: 'tool',
};

export const defaultItems = {
    entrances_hall_closets: [
        'Ceilings, Walls, Trim',
        'Floors/Covering',
        'Windows/Screens',
        'Electrical Fixtures',
        'Blinds/Curtains',
        'Other',
    ],
    kitchen: [
        'Walls, Trim',
        'Ceilings, Walls, Trim',
        'Floorcoverings, Sinks',
        'Cupboards/Doors',
        'Stove/Hood',
        'Dishwasher',
        'Fridge',
        'Washer/Screens',
        'Electrical Fixtures',
        'Blinds/Curtains',
        'Other',
    ],
    living_dining_room: [
        'Ceilings, Walls, Trim',
        'Floors, Closets',
        'Blinds, Drapes, Rods',
        'Windows, Screens',
        'Electrical Fixtures',
        'Other',
    ],
    bedroom1: [
        'Ceilings, Walls, Trim',
        'Closets, Doors, Trim',
        'Floorcovering',
        'Blinds, Drapes, Rods',
        'Window, Screens',
        'Electrical Fixtures',
        'Other',
    ],
    bedroom2: [
        'Ceilings, Walls, Trim',
        'Closets, Doors, Trim',
        'Floorcovering',
        'Blinds, Drapes, Rods',
        'Window, Screens',
        'Electrical Fixtures',
        'Other',
    ],
    bedroom3: [
        'Ceilings, Walls, Trim',
        'Closets, Doors',
        'Floorcovering',
        'Blinds, Drapes, Rods',
        'Windows, Screens',
        'Electrical Fixtures',
        'Other',
    ],
    bathroom1: [
        'Ceilings, Walls, Trim',
        'Floors/Covering',
        'Electrical Fixtures',
        'Windows, Screens',
        'Toilet',
        'Sink, Vanity, Mirrors',
        'Other',
    ],
    bathroom2: [
        'Walls, Trim',
        'Ceilings, Walls, Trim',
        'Closets, Doors, Trim',
        'Floors/Covering',
        'Electrical Fixtures',
        'Windows, Screens',
        'Toilet',
        'Bath/Shower',
        'Sink, Vanity, Mirrors',
        'Other',
    ],
    miscellaneous: [
        'Smoke Detector & Battery',
        'Other',
    ],
    other_duplex: [
        'Furnace / Duplex',
        'Hot Water Heater',
        'Balcony / Patio Doors',
        'Storage Room',
        'Yard, Fence',
        'Garage, Dryer',
        'Other Appliances',
    ],
};

const setNestedTouched = (obj, touched = {}) => {
    Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
            touched[key] = setNestedTouched(obj[key], {});
        } else {
            touched[key] = true;
        }
    });
    return touched;
};

export { setNestedTouched };

/**
 * Checks if a section is complete based on the current phase.
 * - Phases 1 & 2 = move-in phase  → only check move_in_condition
 * - Phases 3 & 4 = move-out phase → only check move_out_condition
 *
 * @param {string} sectionKey
 * @param {object} values - formik values
 * @param {object} touched - formik touched
 * @param {object} errors - formik errors
 * @param {number} currentPhase - 1 | 2 | 3 | 4
 */
const isSectionComplete = (sectionKey, values, touched, errors, currentPhase) => {
    const itemsInSection = values.inspection_items?.filter(item => item.section === sectionKey) || [];

    if (itemsInSection.length === 0) return true;

    // Determine which side(s) to check based on phase
    const checkMoveIn = [1, 2].includes(currentPhase);
    const checkMoveOut = [3, 4].includes(currentPhase);

    return itemsInSection.every(item => {
        const inCond = item.move_in_condition || {};
        const outCond = item.move_out_condition || {};

        if (checkMoveIn) {
            const hasCondition = inCond.code != null && [1, 2, 3, 4, 5, 6].includes(inCond.code);
            const hasMediaIfNeeded = ![2, 3, 4].includes(inCond.code) || (inCond.attachments?.length > 0);
            if (!hasCondition || !hasMediaIfNeeded) return false;
        }

        if (checkMoveOut) {
            const hasCondition = outCond.code != null && [1, 2, 3, 4, 5, 6].includes(outCond.code);
            const hasMediaIfNeeded = ![2, 3, 4].includes(outCond.code) || (outCond.attachments?.length > 0);
            if (!hasCondition || !hasMediaIfNeeded) return false;
        }

        return true;
    });
};

export { isSectionComplete };